import { render } from "./LayoutNoHeader.vue?vue&type=template&id=6b93a1b1"
import script from "./LayoutNoHeader.vue?vue&type=script&lang=js"
export * from "./LayoutNoHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__